// extracted by mini-css-extract-plugin
export default {"list":"TestimonialList_list__RTtWn","item":"TestimonialList_item__omo6j","content":"TestimonialList_content__W4ZmH","text":"TestimonialList_text__XDjP6"};